import { createClient } from '@supabase/supabase-js';
import { envs } from '../common/config';

export const supabase = createClient(envs.supabaseUrl, envs.supabaseAnonKey);
